// Klanten waarvan de ijskarren op de CloudFactory Radar getoond worden.
// Per klant een company_id (zoals in de IceCorp API) + de klantnaam die in
// het label verschijnt. De kleur wordt automatisch afgeleid van het id
// (zie colors.js), dus elke klant krijgt een eigen, stabiele kleur.
//
// De id's zijn bepaald door het publieke endpoint af te toetsen
// (v1/icecreamvanmarkerdata?company_id=..) op klanten met ijskarren.
//
// Uitbreiden met een nieuwe klant = één regel toevoegen.
export const COMPANIES = [
	{ id: 2, name: "Foubert" },
	{ id: 4, name: "Joris IJs" },
	{ id: 8, name: "Tartiste" },
	{ id: 10, name: "De Krijmboer" },
	{ id: 11, name: "Vanilla+" },
	{ id: 12, name: "Boerenijsje" },
	{ id: 16, name: "De Post" },
	{ id: 18, name: "Pinguino" },
	{ id: 21, name: "Ice Monkey" },
	{ id: 22, name: "Barbol" },
	{ id: 24, name: "Pierino" },
	{ id: 26, name: "Ralph & Roxy" },
];

export default COMPANIES;
